<template>
    <GiVendorIndex
        pageTitle="GI Vendor Transfer Warehouse"
        :isCentralWarehouse="false"
        commitRouteName="outbound-delivery-transfer-warehouse-commit"
        :order-type="orderTypeStockTransfer"
        :skipWarehouseSelection="true"
    />
</template>

<script>
import GiVendorIndex from "../components/GiVendorIndex.vue";
import { ORDER_TYPE } from "@/constants/outbound";

export default {
    components: {
        GiVendorIndex,
    },

    computed: {
        orderTypeStockTransfer() {
            return ORDER_TYPE.TRANSFER_WAREHOUSE
        }
    }
}
</script>
